import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";
import type { ApiQueryParams } from "@/types/api-types";

export const useTicketCategoryQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    list: () =>
      queryOptions({
        queryKey: QUERY_KEYS.TICKET_CATEGORIES(projectId),
        queryFn: () => api.getTicketCategoriesV1(),
        select: commonAPIDataSelector,
      }),
    details: ({ categoryId }: { categoryId: string }) =>
      queryOptions({
        queryKey: QUERY_KEYS.TICKET_CATEGORY(projectId, categoryId),
        queryFn: () => api.getTicketCategoriesDetailsV1(categoryId),
        select: commonAPIDataSelector,
      }),
    treeDetails: (categoryId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.TICKET_CATEGORY_TREE(projectId, categoryId),
        queryFn: () => api.getTicketCategoryTreeDetailsV1(categoryId),
        select: commonAPIDataSelector,
      }),
    listCategoryCreatables: (query?: ApiQueryParams<"getTicketCategoriesCreatableV2">) =>
      queryOptions({
        queryKey: QUERY_KEYS.TICKET_CATEGORY_CREATABLES_LIST(projectId, query),
        queryFn: () => api.getTicketCategoriesCreatableV2(query),
        select: commonAPIDataSelector,
      }),
    categoryCreatableDetails: ({
      categoryId,
      query,
    }: {
      categoryId: string;
      query?: ApiQueryParams<"getTicketCategoriesCreatableDetailsV2", 1>;
    }) =>
      queryOptions({
        queryKey: QUERY_KEYS.TICKET_CATEGORY_CREATABLE_DETAILS(projectId, categoryId, query),
        queryFn: () => api.getTicketCategoriesCreatableDetailsV2(categoryId, query),
        select: commonAPIDataSelector,
      }),
    listAssignees: () =>
      queryOptions({
        queryKey: QUERY_KEYS.TICKET_ASSIGNEES(projectId),
        queryFn: () => api.getUsersRepairAssigneesV1(),
        select: commonAPIDataSelector,
      }),
  };
};
